<template>
  <!-- <div class="app-container"> -->
  <div class="">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <!-- <el-form-item label="主键" prop="pid">
        <el-input
          v-model="queryParams.pid"
          placeholder="请输入主键"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="租户" prop="tenantId">
        <el-input
          v-model="queryParams.tenantId"
          placeholder="请输入租户"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item> -->
      <el-form-item label="姓名" prop="trueName">
        <el-input
          v-model="queryParams.trueName"
          placeholder="请输入姓名"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <!-- <el-form-item label="身份证号" prop="idCardNumber">
        <el-input
          v-model="queryParams.idCardNumber"
          placeholder="请输入身份证号"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item> -->
      <!-- <el-form-item label="性别" prop="gender">
        <el-input
          v-model="queryParams.gender"
          placeholder="请输入性别"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item> -->
      <!-- <el-form-item label="联系方式" prop="contactInformation">
        <el-input
          v-model="queryParams.contactInformation"
          placeholder="请输入联系方式"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item> -->
      <el-form-item label="职务" prop="position">
        <el-input
          v-model="queryParams.position"
          placeholder="请输入职务"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="职称" prop="professionalTitle">
        <el-input
          v-model="queryParams.professionalTitle"
          placeholder="请输入职称"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <!-- <el-form-item label="法定代表人身份" prop="legalRepresentative">
        <el-input
          v-model="queryParams.legalRepresentative"
          placeholder="请输入法定代表人身份"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item> -->
      <!-- <el-form-item label="身份证正面" prop="frontCard">
        <el-input
          v-model="queryParams.frontCard"
          placeholder="请输入身份证正面"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="身份证反面" prop="reverseCard">
        <el-input
          v-model="queryParams.reverseCard"
          placeholder="请输入身份证反面"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item> -->
      <!-- <el-form-item label="社保" prop="socialInsurance">
        <el-input
          v-model="queryParams.socialInsurance"
          placeholder="请输入社保"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item> -->
      <!-- <el-form-item label="劳务合同" prop="laborContract">
        <el-input
          v-model="queryParams.laborContract"
          placeholder="请输入劳务合同"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="证书资料" prop="certificateNformation">
        <el-input
          v-model="queryParams.certificateNformation"
          placeholder="请输入证书资料"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item> -->
      <!-- <el-form-item label="版本" prop="version">
        <el-input
          v-model="queryParams.version"
          placeholder="请输入版本"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item> -->
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="el-icon-plus"
          size="mini"
          @click="handleAdd"
          v-hasPermi="['creditlibrary:personnelstatus:add']"
        >新增</el-button>
      </el-col>
      <!-- <el-col :span="1.5">
        <el-button
          type="success"
          plain
          icon="el-icon-edit"
          size="mini"
          :disabled="single"
          @click="handleUpdate"
          v-hasPermi="['creditlibrary:personnelstatus:edit']"
        >修改</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="danger"
          plain
          icon="el-icon-delete"
          size="mini"
          :disabled="multiple"
          @click="handleDelete"
          v-hasPermi="['creditlibrary:personnelstatus:remove']"
        >删除</el-button>
      </el-col> -->
      <el-col :span="1.5">
        <el-button
          type="warning"
          plain
          icon="el-icon-download"
          size="mini"
          @click="handleExport"
          v-hasPermi="['creditlibrary:personnelstatus:export']"
        >导出</el-button>
      </el-col>
      <right-toolbar :showSearch.sync="showSearch" @queryTable="getList"></right-toolbar>
    </el-row>
<!-- border -->
    <el-table v-loading="loading" :data="personnelstatusList" @selection-change="handleSelectionChange"   max-height="650">
      <el-table-column type="selection" width="40" align="center" />
      <!-- <el-table-column label="主键" align="center" prop="pid" /> -->
      <!-- <el-table-column label="租户" align="center" prop="tenantId" /> -->
      <el-table-column label="姓名" align="center" prop="trueName" />
      <el-table-column label="身份证号" align="center" prop="idCardNumber" />
      <el-table-column label="性别" align="center" prop="gender" />
      <el-table-column label="联系方式" align="center" prop="contactInformation" />
      <el-table-column label="职务" align="center" prop="position" />
      <el-table-column label="职称" align="center" prop="professionalTitle" />
      <el-table-column label="法定代表人身份" align="center" prop="legalRepresentative" />
      <el-table-column label="身份证正面" align="center" prop="frontCard" />
      <el-table-column label="身份证反面" align="center" prop="reverseCard" />
      <el-table-column label="社保" align="center" prop="socialInsurance" />
      <el-table-column label="劳务合同" align="center" prop="laborContract" />
      <el-table-column label="证书资料" align="center" prop="certificateNformation" />
      <!-- <el-table-column label="版本" align="center" prop="version" /> -->
      <el-table-column label="操作" align="center" class-name="small-padding fixed-width" width="120" fixed="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
            v-hasPermi="['creditlibrary:personnelstatus:edit']"
          >修改</el-button>
          <el-button
            size="mini"
            type="text"
            icon="el-icon-delete"
            @click="handleDelete(scope.row)"
            v-hasPermi="['creditlibrary:personnelstatus:remove']"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :total="total"
      :page.sync="queryParams.pageNum"
      :limit.sync="queryParams.pageSize"
      @pagination="getList"
    />

    <!-- 添加或修改人员情况对话框 -->
    <el-dialog :title="title" :visible.sync="open" width="800px" append-to-body :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="120px">
        <!-- <el-form-item label="主键" prop="pid">
          <el-input v-model="form.pid" placeholder="请输入主键" />
        </el-form-item>
        <el-form-item label="租户" prop="tenantId">
          <el-input v-model="form.tenantId" placeholder="请输入租户" />
        </el-form-item> -->
        <el-row>
<el-col :span="12">
 <el-form-item label="姓名" prop="trueName">
          <el-input v-model="form.trueName" placeholder="请输入姓名" />
        </el-form-item>
</el-col>
<el-col :span="12">
 <el-form-item label="身份证号" prop="idCardNumber">
          <el-input v-model="form.idCardNumber" placeholder="请输入身份证号" />
        </el-form-item>

</el-col>

        </el-row>
       
               <el-row>
<el-col :span="12">
        <el-form-item label="性别" prop="gender">
          <el-input v-model="form.gender" placeholder="请输入性别" />
        </el-form-item>
        </el-col>
        <el-col :span="12">
        <el-form-item label="联系方式" prop="contactInformation">
          <el-input v-model="form.contactInformation" placeholder="请输入联系方式" />
        </el-form-item>
        </el-col>
        </el-row>
        <el-row>
<el-col :span="12">
        <el-form-item label="职务" prop="position">
          <el-input v-model="form.position" placeholder="请输入职务" />
        </el-form-item>
        </el-col>
        <el-col :span="12">
        <el-form-item label="职称" prop="professionalTitle">
          <el-input v-model="form.professionalTitle" placeholder="请输入职称" />
        </el-form-item>
</el-col>
</el-row>
             <el-row>
<el-col :span="12">
        <el-form-item label="法定代表人身份" prop="legalRepresentative">
          <el-input v-model="form.legalRepresentative" placeholder="请输入法定代表人身份" />
        </el-form-item>
        </el-col>
        <el-col :span="12">
        <el-form-item label="身份证正面" prop="frontCard">
          <el-input v-model="form.frontCard" placeholder="请输入身份证正面" />
        </el-form-item>
        </el-col>
      </el-row>
                   <el-row>
<el-col :span="12">
        <el-form-item label="身份证反面" prop="reverseCard">
          <el-input v-model="form.reverseCard" placeholder="请输入身份证反面" />
        </el-form-item>
        </el-col>
        <el-col :span="12">
        <el-form-item label="社保" prop="socialInsurance">
          <el-input v-model="form.socialInsurance" placeholder="请输入社保" />
        </el-form-item>
        </el-col>
        </el-row>
                     <el-row>
<el-col :span="12">
        <el-form-item label="劳务合同" prop="laborContract">
          <el-input v-model="form.laborContract" placeholder="请输入劳务合同" />
        </el-form-item>
        </el-col>
        <el-col :span="12">
        <el-form-item label="证书资料" prop="certificateNformation">
          <el-input v-model="form.certificateNformation" placeholder="请输入证书资料" />
        </el-form-item>
        </el-col>
        </el-row>
        <!-- <el-form-item label="版本" prop="version">
          <el-input v-model="form.version" placeholder="请输入版本" />
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { listPersonnelstatus, getPersonnelstatus, delPersonnelstatus, addPersonnelstatus, updatePersonnelstatus } from "@/api/creditlibrary/personnelstatus";

export default {
  name: "Personnelstatus",
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 人员情况表格数据
      personnelstatusList: [],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        pid: null,
        tenantId: null,
        trueName: null,
        idCardNumber: null,
        gender: null,
        contactInformation: null,
        position: null,
        professionalTitle: null,
        legalRepresentative: null,
        frontCard: null,
        reverseCard: null,
        socialInsurance: null,
        laborContract: null,
        certificateNformation: null,
        version: null,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询人员情况列表 */
    getList() {
      this.loading = true;
      listPersonnelstatus(this.queryParams).then(response => {
        this.personnelstatusList = response.rows;
        this.total = response.total;
        this.loading = false;
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        pid: null,
        tenantId: null,
        trueName: null,
        idCardNumber: null,
        gender: null,
        contactInformation: null,
        position: null,
        professionalTitle: null,
        legalRepresentative: null,
        frontCard: null,
        reverseCard: null,
        socialInsurance: null,
        laborContract: null,
        certificateNformation: null,
        version: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null
      };
      this.resetForm("form");
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.ids = selection.map(item => item.pid)
      this.single = selection.length!==1
      this.multiple = !selection.length
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = "添加人员情况";
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const pid = row.pid || this.ids
      getPersonnelstatus(pid).then(response => {
        this.form = response.data;
        this.open = true;
        this.title = "修改人员情况";
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          if (this.form.pid != null) {
            updatePersonnelstatus(this.form).then(response => {
              this.$modal.msgSuccess("修改成功");
              this.open = false;
              this.getList();
            });
          } else {
            addPersonnelstatus(this.form).then(response => {
              this.$modal.msgSuccess("新增成功");
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const pids = row.pid || this.ids;
      this.$modal.confirm('是否确认删除人员情况编号为"' + pids + '"的数据项？').then(function() {
        return delPersonnelstatus(pids);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess("删除成功");
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('creditlibrary/personnelstatus/export', {
        ...this.queryParams
      }, `personnelstatus_${new Date().getTime()}.xlsx`)
    }
  }
};
</script>
